<!-- Hotel Section -->
<div class="ion-margin-top hotel-section" *ngIf="hotelList">
  <ion-title
    class="fs-4 font600 title-text-color marb10"
    *ngIf="entityLabel && hotelList.length > 0"
  >
    Hotels at {{ entityLabel }}
  </ion-title>

  <div class="banner-carousel ion-padding-horizontal">
    <ng-container *ngIf="!loading && hotelList.length > 0; else skeletonLoader">
      <swiper-container
        class="hotel-swiper"
        pager="false"
        [slidesPerView]="1.3"
        [freeMode]="true"
        [passiveListeners]="true"
        [spaceBetween]="10"
      >
        <swiper-slide class="padb10" *ngFor="let hotelDetail of hotelList">
          <ion-card
            class="grey-border border-r8 ion-no-margin padb5 ion-margin-bottom"
          >
            <div class="img-container">
              <ion-img
                class="card-img"
                [src]="hotelDetail?.image || imagePlaceholder"
                (ionError)="hotelDetail.image = imagePlaceholder"
                (click)="navigateToHotelDetail(hotelDetail)"
              ></ion-img>
            </div>

            <ion-card-header class="ion-padding-horizontal ion-no-padding">
              <div class="ion-bg-white d-flex" lines="none">
                <h5
                  class="fs-2 font600 flex-1 card-primary-text-color ion-no-margin mart10 marb6 line-3-clip"
                >
                  {{ hotelDetail?.title }}
                </h5>

                <ion-label
                  class="ion-text-end ion-no-margin ion-no-padding mart10"
                >
                  <p
                    class="ion-no-margin fs-2 font600 text-striked padl10 strike-price-color"
                    *ngIf="
                      hotelDetail?.data?.roomDetail?.priceDetail
                        ?.maxTotalPrice !==
                      hotelDetail?.data?.roomDetail?.priceDetail?.totalPrice
                    "
                  >
                    {{
                      hotelDetail?.data?.roomDetail?.priceDetail?.maxTotalPrice
                        | currency
                          : hotelDetail?.data?.roomDetail?.priceDetail?.currency
                    }}
                  </p>
                  <ion-text color="dark">
                    <p
                      class="ion-no-margin fs-3 font700 padl10 primary-price-color"
                    >
                      {{
                        hotelDetail?.data?.roomDetail?.priceDetail?.totalPrice
                          | currency
                            : hotelDetail?.data?.roomDetail?.priceDetail
                                ?.currency
                      }}
                    </p>
                  </ion-text>
                </ion-label>
              </div>
            </ion-card-header>
          </ion-card>
        </swiper-slide>
      </swiper-container>
    </ng-container>

    <!-- Fallback Skeleton While Loading -->
    <ng-template #skeletonLoader>
      <ng-container *ngIf="loading">
        <ion-card class="grey-border border-r8 ion-no-margin padb5 marb10">
          <div class="img-container">
            <ion-skeleton-text animated class="card-img"></ion-skeleton-text>
          </div>
          <ion-card-header class="ion-padding-horizontal ion-no-padding">
            <div class="ion-bg-white d-flex" lines="none">
              <ion-skeleton-text
                animated
                class="fs-4 font600 flex-1 ion-no-margin mart10 marb6"
              ></ion-skeleton-text>
              <ion-label
                class="ion-text-end ion-no-margin ion-no-padding mart10"
              >
                <ion-skeleton-text
                  animated
                  class="fs-2 font600 padl10"
                ></ion-skeleton-text>
                <ion-skeleton-text
                  animated
                  class="fs-4 font700 padl10"
                ></ion-skeleton-text>
              </ion-label>
            </div>
          </ion-card-header>
        </ion-card>
      </ng-container>
    </ng-template>
  </div>
</div>

<!-- Lounge Section -->
<div class="ion-margin-top" *ngIf="loungeList && loungeListKeys().length > 0">
  <div *ngFor="let airportCode of loungeListKeys()">
    <!-- Show title only if lounges exist for this code -->
    <ion-title
      class="fs-4 font600 ion-padding-horizontal title-text-color"
      *ngIf="loungeList[airportCode]?.length > 0"
    >
      Lounges at {{ airportCode.split(" - ")[0] }} - Terminal
      {{ airportCode.split(" - ")[2] }} {{ airportCode.split(" - ")[1] }}
    </ion-title>

    <div>
      <ng-container
        *ngIf="!loungeLoading && loungeList[airportCode]; else skeletonLoader"
      >
        <div
          class="ion-padding-horizontal ion-margin-bottom"
          *ngIf="loungeList[airportCode]?.length > 1"
        >
          <retail-carousel
            [retailers]="loungeList[airportCode]"
            [baseUrl]="'/lounge'"
          ></retail-carousel>
        </div>

        <div
          class="ion-no-padding padb10 ion-margin-bottom"
          *ngIf="loungeList[airportCode]?.length === 1"
        >
          <primary-list-card
            [itemInfo]="loungeList[airportCode][0]"
            (performAction)="handleRedirect($event)"
          ></primary-list-card>
        </div>
      </ng-container>

      <ng-template #skeletonLoader>
        <ng-container *ngIf="loungeLoading">
          <div class="ion-padding-horizontal">
            <ion-card class="border-r8 ion-no-margin marr10">
              <div class="img-container" style="height: 150px">
                <ion-skeleton-text
                  animated
                  class="ion-no-margin"
                ></ion-skeleton-text>
                <ion-skeleton-text animated class="fs-4"></ion-skeleton-text>
              </div>
            </ion-card>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </div>
</div>

<!-- Meet & Greet Section -->
<div class="ion-margin-top">
  <ion-title class="fs-4 font600 title-text-color">
    Meet & Greet Services
  </ion-title>
  <div class="banner-carousel ion-padding-horizontal">
    <ion-card (click)="navigate()" class="ion-no-margin border-r10 padt10">
      <img
        [src]="
          'https://img.travelx.ai/RETAILERS/thomascook_meet%26greet_app_Apr14_4152025_11548_PM.png' ||
          imagePlaceholder
        "
        (ionError)="
          ('https://img.travelx.ai/RETAILERS/thomascook_meet%26greet_app_Apr14_4152025_11548_PM.png' ||
            imagePlaceholder)
        "
      />
    </ion-card>
  </div>
</div>
